(function() {


  zfrespond.views.MobileVideoInterstitial = Backbone.View.extend({
    
    className: 'mobile-video-interstitial',

    events: {
      'click': 'handleClick',
    },

    template: ZFRESPOND_JST['respond.mobile_video_interstitial'],

    initialize: function() {
      this.deferred = $.Deferred();
    },
    
    getPromise: function(){
      return this.deferred.promise();
    },
    
    render: function() {
      this.$el.html(this.template({}));
    },
    
    handleClick: function() {
      this.deferred.resolve();
    }
    
  });

}());